let posthogInstance = null;
let initialized = false;
let pendingPageViews = [];

const posthogToken = import.meta.env.VITE_PUBLIC_POSTHOG_TOKEN;
const configuredPostHogHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;
const directPostHogHost = configuredPostHogHost || 'https://us.i.posthog.com';
const posthogHost =
  import.meta.env.PROD && directPostHogHost === 'https://us.i.posthog.com'
    ? '/cg-collect'
    : directPostHogHost;

export const isPostHogConfigured = Boolean(posthogToken);

export const initPostHog = async () => {
  if (!isPostHogConfigured || initialized || typeof window === 'undefined') {
    return posthogInstance;
  }

  try {
    const { default: posthog } = await import('posthog-js');
    posthog.init(posthogToken, {
      api_host: posthogHost,
      defaults: '2026-01-30',
      capture_pageview: false,
      capture_pageleave: true,
      autocapture: true,
      person_profiles: 'identified_only',
      ui_host: 'https://us.posthog.com',
    });

    initialized = true;
    posthogInstance = posthog;

    pendingPageViews.forEach(({ path, properties }) => {
      posthog.capture('$pageview', {
        $current_url: window.location.href,
        path,
        ...properties,
      });
    });
    pendingPageViews = [];

    return posthog;
  } catch {
    return null;
  }
};

export const getPostHogClient = () => posthogInstance;

export const capturePostHogPageView = (path, properties = {}) => {
  if (typeof window === 'undefined') return;

  if (!initialized || !posthogInstance) {
    pendingPageViews.push({ path, properties });
    return;
  }

  posthogInstance.capture('$pageview', {
    $current_url: window.location.href,
    path,
    ...properties,
  });
};

export const capturePostHogEvent = (eventName, properties = {}) => {
  if (!initialized || !posthogInstance) return;
  posthogInstance.capture(eventName, properties);
};
